$(function(){
    const results = $('.specResults:not(.related) .specResults-item');
    let data = [];
    let toggle = $('.emailResults-toggle');

    toggle.on('click', function(){
        $('.emailResults').toggleClass('active');
    });

    results.each(function(){
        let title = $(this).find('p.h4').text();
        data.push(title + ' - ' + this.href + ' \n\n');
    });
    data = data.toString();
    data = data.replace(/,/g,'');
    $('input[name="results"]').val(data);

});


// WEBPACK FOOTER //
// ./scripts/components/emailResults.js